window.onscroll = function () {
  var elem = document.querySelector("#product-form");
  var stickyFormContainer = document.querySelector(".sticky-form-container");
  if (elem != null && stickyFormContainer != null) {
    var isOutOfViewport = function (elem) {
      // Get element's bounding
      var bounding = elem.getBoundingClientRect();
      var stickyHeight = document.querySelector("#product-form form").offsetHeight;
      var bottom = bounding.bottom + stickyHeight - 100;

      // Check if it's out of the viewport on each side
      var out = {};
      out.top = bounding.top < 0;
      out.left = bounding.left < 0;
      out.bottom =
        bottom > (window.innerHeight || document.documentElement.clientHeight);
      out.right =
        bounding.right >
        (window.innerWidth || document.documentElement.clientWidth);
      out.any = out.top || out.left || out.bottom || out.right;
      out.all = out.top && out.left && out.bottom && out.right;

      return out;
    };
    var isOut = isOutOfViewport(elem);
    if (isOut.bottom == false) {
      stickyFormContainer.classList.add("sticky-form");
    } else {
      stickyFormContainer.classList.remove("sticky-form");
    }
    // console.log(isOut.bottom);
  }
};
